﻿(function ($) {
    //$.validator.setDefaults({
    //    showErrors: function (errorMap, errorList) {
    //        var errors = errorList.length;
    //        if (errors) {
    //            $(this.currentForm).find('button[type="submit"]').prop('disabled', true);
    //        } else {
    //            $(this.currentForm).find('button[type="submit"]').prop('disabled', false);
    //        }
    //        this.defaultShowErrors();
    //    }
    //});

    $.validator.unobtrusive.adapters.addBool('booleanrequired', 'required');

    $.validator.addMethod('conditionalrequired', function (value, element, params) {
        var fieldNamePrefix = $(element).attr('name').substring(0, $(element).attr('name').lastIndexOf('.') + 1);
        var propertyValue = $(element).parents('form').find('[name="' + fieldNamePrefix + params[0] + '"]').val();
        var allowedValues = params[1].split(',');
        var returnVal = true;

        $.each(allowedValues, function (i, allowedValue) {
            if (propertyValue && propertyValue === allowedValue) {
                returnVal = $.trim(value).length > 0;
                return false; //break
            }
        });

        return returnVal;
    });

    $.validator.unobtrusive.adapters.add('conditionalrequired', ['propertyname', 'allowedvalues'], function (options) {
        options.rules['conditionalrequired'] = [options.params['propertyname'], options.params['allowedvalues']];
        options.messages['conditionalrequired'] = options.message;
    });

    $.validator.addMethod('conditionalregex', function (value, element, params) {
        var fieldNamePrefix = $(element).attr('name').substring(0, $(element).attr('name').lastIndexOf('.') + 1);
        var propertyValue = $(element).parents('form').find('[name="' + fieldNamePrefix + params[1] + '"]').val();

        if (propertyValue && propertyValue.toLowerCase() === params[2].toLowerCase()) {
            var r = new RegExp(params[0]);
            return r.test(value);
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add('conditionalregex', ['pattern', 'propertyname', 'propertyvalue'], function (options) {
        options.rules['conditionalregex'] = [options.params['pattern'], options.params['propertyname'], options.params['propertyvalue']];
        options.messages['conditionalregex'] = options.message;
    });

    $('[data-val-required], [data-val-booleanrequired]').each(function () {
        if (!$(this).is('[type="checkbox"]') || $(this).is('[data-val-booleanrequired]')) {
            var label = $('label[for="' + $(this).attr('id') + '"]');
            label.addClass('required');
        }
    });
}(jQuery));